import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Alert as Alert$1, AlertIcon, Avatar as Avatar$1, Box as Box$1, theme, extendTheme as extendTheme$1, ChakraProvider, ColorModeScript, Icon as Icon$1, Button as Button$1, Checkbox as Checkbox$1, FormControl as FormControl$1, FormLabel, FormHelperText, FormErrorMessage, CheckboxGroup as CheckboxGroup$1, Wrap as Wrap$1, Stack as Stack$1, Collapse as Collapse$1, Container as Container$1, forwardRef as forwardRef$1, useTheme, InputLeftElement, InputLeftAddon, Input as Input$1, InputRightElement, InputRightAddon, InputGroup, Popover as Popover$1, PopoverTrigger, PopoverContent, PopoverBody, SimpleGrid as SimpleGrid$1, Heading as Heading$1, useColorModeValue as useColorModeValue$1, Text as Text$1, Divider as Divider$1, Image as Image$1, Kbd as Kbd$1, Link as Link$1, ListItem as ListItem$1, OrderedList, UnorderedList, Spinner, chakra, useBreakpointValue, MenuButton as MenuButton$1, MenuList, MenuItem, MenuGroup, MenuDivider, MenuOptionGroup, MenuItemOption, Menu as Menu$1, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, NumberInput as NumberInput$1, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Radio as Radio$1, RadioGroup as RadioGroup$1, Select as Select$1, Tabs as Tabs$1, TabList as TabList$1, TabPanels as TabPanels$1, TabPanel as TabPanel$1, Tab as Tab$1, Tag as Tag$1, TagLabel, TagCloseButton, Textarea as Textarea$1, Tooltip as Tooltip$1, WrapItem as WrapItem$1, Skeleton as Skeleton$1, SkeletonCircle as SkeletonCircle$1, SkeletonText as SkeletonText$1 } from '@chakra-ui/react';
export { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, CSSReset, GridItem, MenuDivider, MenuGroup, MenuItem, MenuItemOption, MenuList, MenuOptionGroup, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Portal, Table, TableCaption, TableContainer, Tbody, Td, Tfoot, Th, Thead, Tr, Grid as WaxGrid, omitThemingProps, useBreakpointValue, useClipboard, useColorMode, useControllableProp, useControllableState, useDisclosure, useMediaQuery, useMultiStyleConfig, useStyleConfig, useStyles, useTheme, useToast, chakra as wax } from '@chakra-ui/react';
import React, { forwardRef, Children, isValidElement, cloneElement, useRef, useEffect, useCallback, useState, useLayoutEffect, memo } from 'react';
import Color$1 from 'color';
import lodashPick from 'lodash.pick';
import { mode, transparentize } from '@chakra-ui/theme-tools';
export { transparentize } from '@chakra-ui/theme-tools';
import { css, Global } from '@emotion/react';
import UntitledSansWebLight from "./assets/untitled-sans-web-light-7eb6313b.woff2";
import UntitledSansWebRegular from "./assets/untitled-sans-web-regular-0b096f8c.woff2";
import UntitledSansWebMedium from "./assets/untitled-sans-web-medium-a211c024.woff2";
import UntitledSansWebBold from "./assets/untitled-sans-web-bold-40815a29.woff2";
import UntitledSansWebBlack from "./assets/untitled-sans-web-black-0a7b5811.woff2";
import UntitledSerifWebRegular from "./assets/untitled-serif-web-regular-73871753.woff2";
import UntitledSerifWebMedium from "./assets/untitled-serif-web-medium-61ee0a9d.woff2";
import UntitledSerifWebBold from "./assets/untitled-serif-web-bold-400547f8.woff2";
import BrownLLThin from "./assets/brown-ll-web-thin-c2b7f5a8.woff2";
import BrownLLLight from "./assets/brown-ll-web-light-aa9e1678.woff2";
import BrownLLMedium from "./assets/brown-ll-web-medium-a08dfbd7.woff2";
import BrownLLRegular from "./assets/brown-ll-web-regular-e19fede5.woff2";
import BrownLLBold from "./assets/brown-ll-web-bold-3fd603e6.woff2";
import * as ChakraIcons from '@chakra-ui/icons';
import { useDayzed } from 'dayzed';
import { format as format$1, startOfDay, addMinutes, setHours, setMinutes, getMinutes, getHours } from 'date-fns';
import { useColorModeValue, keyframes, useTheme as useTheme$1 } from '@chakra-ui/system';
import Background from "./assets/background-5b9436d5.jpg";

Accordion.displayName = "Accordion";
AccordionItem.displayName = "AccordionItem";
AccordionButton.displayName = "AccordionButton";
AccordionPanel.displayName = "AccordionPanel";
AccordionIcon.displayName = "AccordionIcon";

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/**
 * Use `Alert` to show important information to the user.
 */
const Alert = forwardRef((_a, ref) => {
    var { status, children, variant = "subtle" } = _a, rest = __rest(_a, ["status", "children", "variant"]);
    return (React.createElement(Alert$1, Object.assign({}, rest, { ref: ref, status: status, variant: variant }),
        React.createElement(AlertIcon, null),
        children));
});
Alert.displayName = "Alert";

// https://noom.github.io/growth/#colors
const Color = {
    gray: {
        dark: "#4D4D4D",
        main: "#969696",
        light: "#CACACA",
        lightest: "#F2F2F2",
    },
    sun: {
        dark: "#C28800",
        main: "#FFCF04",
        light: "#FFE782",
        lightest: "#FFF5CD",
    },
    orange: {
        dark: "#C36000",
        main: "#FF8A1A",
        light: "#F8BD85",
        lightest: "#FFE7CF",
    },
    cherry: {
        dark: "#9C0300",
        main: "#E73B37",
        light: "#EC9694",
        lightest: "#FFDAD9",
    },
    watermelon: {
        dark: "#B12C37",
        main: "#F75462",
        light: "#FBA9B0",
        lightest: "#FFDEE1",
    },
    eggplant: {
        dark: "#6F1056",
        main: "#BB4F9F",
        light: "#D6A0C8",
        lightest: "#FDDDF5",
    },
    violet: {
        dark: "#2F0062",
        main: "#7A00FD",
        light: "#B578F7",
        lightest: "#F1E4FF",
    },
    pbr: {
        dark: "#183C78",
        main: "#447AD4",
        light: "#A1BCE9",
        lightest: "#ECF2FB",
    },
    sea: {
        dark: "#005254",
        main: "#30C1C5",
        light: "#90D9DB",
        lightest: "#E4FEFF",
    },
    apple: {
        dark: "#123806",
        main: "#16AA00",
        light: "#83CD78",
        lightest: "#E9FFE3",
    },
};
const CompassColor = {
    // Reds/Oranges
    cherry: "#5F110E",
    cinnamon: "#AA3521",
    tarocco: "#FB513B",
    salmon: "#F4BEAE",
    // Purples/Pinks
    plum: "#671D48",
    berry: "#A82F67",
    blossom: "#F2AACD",
    conch: "#EBCCD9",
    // Greens
    pine: "#2B4010",
    kale: "#316700",
    avocado: "#799F2D",
    sprout: "#A9D15A",
    mint: "#C8E3B1",
    mintLight: "#E3F1D8",
    // Blues
    blueberry: "#1D3A44",
    lagoon: "#05727A",
    stream: "#6CC1B6",
    sky: "#B4E0D8",
    // Yellows
    yolk: "#EAAF00",
    // Tans
    gold: "#AD925E",
    sand01: "#E4DECE",
    sand02: "#D3C9B4",
    offWhite: "#F6F4EE",
    // Whites/Greys/Blacks
    white: "#FFFFFF",
    grey1: "#DEDEDE",
    grey2: "#AAAAAA",
    grey3: "#666666",
    // duplicated for backwards compatibility
    stone: "#666666",
    grey4: "#444444",
    black: "#191717",
};
const Size = {
    xxxl: "3xl",
    xxl: "2xl",
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs",
};
const Variant = {
    outline: "outline",
    filled: "filled",
    flushed: "flushed",
    unstyled: "unstyled",
    ghost: "ghost",
    link: "link",
    solid: "solid",
};
const Status = {
    info: "info",
    success: "success",
    warning: "warning",
    error: "error",
};
const ColorScheme = Object.assign(Object.assign({}, Status), { primary: "primary", secondary: "secondary", gray: "gray" });
const VariantColor = ColorScheme;
const Spacing = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    8: 8,
    10: 10,
    12: 12,
    16: 16,
    20: 20,
    24: 24,
    32: 32,
    40: 40,
    48: 48,
    56: 56,
    64: 64,
};
const Align = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
};
const Justify = {
    start: "flex-start",
    end: "flex-end",
    center: "center",
    between: "space-between",
    around: "space-around",
    evenly: "space-evenly",
};
const Placement = {
    top: "top",
    bottom: "bottom",
    left: "left",
    right: "right",
};
const Direction = {
    column: "column",
    columnReverse: "column-reverse",
    row: "row",
    rowReverse: "row-reverse",
};

const lighten = (color, amount) => Color$1(color).lighten(amount).hex();
const darken = (color, amount) => Color$1(color).darken(amount).hex();
const generateColorPalette = (color) => ({
    900: darken(color, 0.7),
    800: darken(color, 0.5),
    700: darken(color, 0.3),
    600: darken(color, 0.15),
    500: color,
    400: lighten(color, 0.15),
    300: lighten(color, 0.3),
    200: lighten(color, 0.5),
    100: lighten(color, 0.7),
    50: lighten(color, 0.88),
});
function pick(obj, args) {
    return lodashPick(obj, args);
}
function getValidChildren(children) {
    return Children.toArray(children).filter((child) => isValidElement(child));
}
// Split time string to return [value: number, unit: string]
function splitTimeUnit(time) {
    var _a, _b;
    const timeRegex = /^([\d.]+)([a-zA-Z]+)$/;
    const match = time.match(timeRegex);
    return [(_a = Number(match === null || match === void 0 ? void 0 : match[1])) !== null && _a !== void 0 ? _a : 0, (_b = match === null || match === void 0 ? void 0 : match[2]) !== null && _b !== void 0 ? _b : "ms"];
}

const AvatarSize = pick(Size, ["xs", "sm", "md", "lg", "xl", "xxl"]);
/**
 * The `Avatar` component is used to represent user, and displays the profile picture or initials.
 */
const Avatar = forwardRef((_a, ref) => {
    var { colorScheme, variantColor } = _a, rest = __rest(_a, ["colorScheme", "variantColor"]);
    const extraProps = {};
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const bg = scheme ? `${scheme}.500` : undefined;
    if (bg) {
        extraProps.bg = bg;
    }
    return React.createElement(Avatar$1, Object.assign({ ref: ref }, rest, extraProps));
});
Avatar.displayName = "Avatar";

/**
 * Box should be mostly used for quickly stylable layout elements.
 * And as building blocks for new components.
 * It is build on top of [styled-system](https://styled-system.com/table/) for easy styling and
 * can use the **as** prop to render as any HTML element.
 */
const Box = forwardRef((props, ref) => {
    return React.createElement(Box$1, Object.assign({ ref: ref }, props));
});
Box.displayName = "Box";

const generateFF = (fontFamily, weight, path) => `
  @font-face {
    font-family: "${fontFamily}";
    src: url("${path}") format("woff2");
    font-style: normal;
    font-weight: ${weight};
  }`;
const fonts = [
    generateFF("Untitled Sans", 300, UntitledSansWebLight),
    generateFF("Untitled Sans", 400, UntitledSansWebRegular),
    generateFF("Untitled Sans", 500, UntitledSansWebMedium),
    generateFF("Untitled Sans", 700, UntitledSansWebBold),
    generateFF("Untitled Sans", 900, UntitledSansWebBlack),
    generateFF("Untitled Serif", 400, UntitledSerifWebRegular),
    generateFF("Untitled Serif", 500, UntitledSerifWebMedium),
    generateFF("Untitled Serif", 700, UntitledSerifWebBold),
    generateFF("Brown LL", 100, BrownLLThin),
    generateFF("Brown LL", 300, BrownLLLight),
    generateFF("Brown LL", 400, BrownLLRegular),
    generateFF("Brown LL", 500, BrownLLMedium),
    generateFF("Brown LL", 700, BrownLLBold),
];
const styles = css `
  ${fonts}
`;
function Fonts() {
    return React.createElement(Global, { styles: styles });
}

const defaultTheme = {
    config: {
        useSystemColorMode: false,
        initialColorMode: "light",
    },
    // Weird export error
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    layerStyles: {},
    colors: {
        primary: generateColorPalette("#ff7f50"),
        secondary: generateColorPalette(Color.pbr.main),
        info: generateColorPalette(Color.sea.main),
        success: generateColorPalette(Color.apple.main),
        warning: generateColorPalette(Color.sun.main),
        error: generateColorPalette(Color.cherry.main),
        gray: theme.colors.gray,
    },
    fonts: {
        body: "Roboto, sans-serif",
        heading: "Roboto, sans-serif",
        mono: "Roboto, sans-serif",
    },
    radii: {
        none: "0",
        sm: "0",
        md: "0",
        lg: "0",
        full: "9999px",
    },
    components: {
        Button: {
            baseStyle: {
                borderRadius: "0.35rem",
            },
            sizes: {
                xl: {
                    height: 16,
                    minWidth: 16,
                    fontSize: "xl",
                    px: 12,
                },
                lg: {
                    height: 12,
                    minWidth: 12,
                    fontSize: "lg",
                    px: 8,
                },
                md: {
                    height: 10,
                    minWidth: 10,
                    fontSize: "md",
                    px: 6,
                },
                sm: {
                    height: 8,
                    minWidth: 8,
                    fontSize: "sm",
                    px: 4,
                },
                xs: {
                    height: 6,
                    minWidth: 6,
                    fontSize: "xs",
                    px: 2,
                },
            },
        },
        CompassLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Input: {
            variants: {
                outline: {
                    field: {
                        bg: "white",
                    },
                },
            },
        },
        NoomLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Popover: {
            variants: {
                responsive: {
                    popper: {
                        maxWidth: "unset",
                        width: "unset",
                    },
                },
            },
        },
        Tag: {
            sizes: {
                sm: { container: { borderRadius: "0.3rem" } },
                md: { container: { borderRadius: "0.35rem" } },
                lg: { container: { borderRadius: "0.35rem" } },
            },
        },
        Tooltip: {
            baseStyle: {
                color: "white",
            },
        },
    },
};
function extendTheme(customTheme) {
    return extendTheme$1(theme, defaultTheme, customTheme);
}
var defaultTheme$1 = extendTheme$1(theme, defaultTheme);

function TP(props) {
    const { children, theme = defaultTheme$1, resetCSS = false, includeFonts = true, } = props;
    return (React.createElement(ChakraProvider, { theme: theme, resetCSS: resetCSS },
        React.createElement(ColorModeScript, { initialColorMode: theme.config.initialColorMode }),
        children,
        includeFonts && React.createElement(Fonts, null)));
}

const compassTheme = {
    config: {
        useSystemColorMode: false,
        initialColorMode: "light",
    },
    layerStyles: {},
    colors: {
        primary: {
            "50": "#ffecef",
            100: "#ffd0d4",
            200: "#f3a09d",
            300: "#ea7b77",
            400: "#f55e54",
            500: "#fb513b",
            600: "#ec473a",
            700: "#da3e34",
            800: "#cc372d",
            900: "#bd2d21",
        },
        secondary: generateColorPalette(CompassColor.white),
        info: {
            50: "#def5f6",
            100: "#aee5e9",
            200: "#7bd4dc",
            300: "#47c2ce",
            400: "#22b6c4",
            500: "#00a9bb",
            600: "#009aaa",
            700: "#038691",
            800: "#05727a",
            900: "#085051",
        },
        success: {
            50: "#f2f7e7",
            100: "#deecc3",
            200: "#c8df9c",
            300: "#b2d273",
            400: "#a1c953",
            500: "#90bf31",
            600: "#81b02a",
            700: "#81b02a",
            800: "#578816",
            900: "#326700",
        },
        warning: {
            50: "#fdfbe4",
            100: "#f9f3bd",
            200: "#f5eb91",
            300: "#f1e465",
            400: "#efdf41",
            500: "#ecd913",
            600: "#ebc70c",
            700: "#eab000",
            800: "#e89700",
            900: "#e56d00",
        },
        error: {
            50: "#fdecee",
            100: "#fbcfd1",
            200: "#e89f9a",
            300: "#dc7b73",
            400: "#e46051",
            500: "#e75538",
            600: "#d94c37",
            700: "#c74331",
            800: "#ba3d2b",
            900: "#aa3621",
        },
        // Generated using https://materialpalettes.com/
        gray: {
            "50": "#fafafa",
            "100": "#f4f4f4",
            "200": "#ededed",
            "300": "#dedede",
            "400": "#bbbbbb",
            "500": "#9c9c9c",
            "600": "#737373",
            "700": "#5f5f5f",
            "800": "#404040",
            "900": "#1f1f1f",
        },
    },
    fonts: {
        body: `"Untitled Sans", sans-serif`,
        heading: `"Untitled Serif", sans-serif`,
        mono: `"Brown LL", sans-serif`,
    },
    components: {
        Button: {
            baseStyle: {
                borderRadius: "8px",
                fontWeight: "medium",
            },
            sizes: {
                xl: {
                    height: 16,
                    minWidth: 16,
                    fontSize: "xl",
                    px: 12,
                },
                lg: {
                    height: 12,
                    minWidth: 12,
                    fontSize: "lg",
                    px: 8,
                },
                md: {
                    height: 10,
                    minWidth: 10,
                    fontSize: "md",
                    px: 6,
                },
                sm: {
                    height: 8,
                    minWidth: 8,
                    fontSize: "sm",
                    px: 4,
                },
                xs: {
                    height: 6,
                    minWidth: 6,
                    fontSize: "xs",
                    px: 2,
                },
            },
        },
        CompassLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Input: {
            variants: {
                outline: {
                    field: {
                        bg: "white",
                    },
                },
            },
        },
        Modal: {
            parts: ["header", "footer", "body"],
            baseStyle: {
                dialog: {
                    borderRadius: "8px",
                    bg: CompassColor.white,
                    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.16)",
                },
                overlay: {
                    bg: "rgba(0, 0, 0, 0.48)",
                },
                header: {
                    fontWeight: "500",
                    textAlign: "center",
                    borderBottom: "1px",
                    borderBottomStyle: "solid",
                    borderColor: CompassColor.sand01,
                    color: CompassColor.black,
                },
                body: {
                    margin: Spacing[5],
                    paddingInline: 0,
                    color: CompassColor.black,
                    fontSize: Size.md,
                },
                footer: {
                    justifyContent: "space-evenly",
                    paddingInline: 0,
                    marginLeft: Spacing[5],
                    marginRight: Spacing[5],
                },
            },
        },
        Select: {
            baseStyle: {
                borderRadius: "8px",
            },
        },
        NoomLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Popover: {
            variants: {
                responsive: {
                    popper: {
                        maxWidth: "unset",
                        width: "unset",
                    },
                },
            },
        },
        Tag: {
            sizes: {
                sm: { container: { borderRadius: "0.3rem" } },
                md: { container: { borderRadius: "0.35rem" } },
                lg: { container: { borderRadius: "0.35rem" } },
            },
        },
        Tooltip: {
            baseStyle: {
                color: "white",
            },
        },
    },
};
function extendCompassTheme(customTheme) {
    return extendTheme$1(theme, compassTheme, customTheme);
}
var compassTheme$1 = extendTheme$1(theme, compassTheme);

const internalTheme = {
    config: {
        initialColorMode: "system",
        useSystemColorMode: true,
    },
    styles: {
        global: (props) => ({
            body: {
                fontFamily: "body",
                color: mode("gray.800", "whiteAlpha.900")(props),
                bg: mode("white", "gray.800")(props),
                transitionProperty: "background-color",
                transitionDuration: "normal",
                lineHeight: "base",
            },
            "*::placeholder": {
                color: mode("gray.400", "whiteAlpha.400")(props),
            },
            "*, *::before, &::after": {
                borderColor: mode("gray.200", "whiteAlpha.300")(props),
                wordWrap: "break-word",
            },
        }),
    },
    colors: {
        primary: {
            50: "#ffecef",
            100: "#ffd0d4",
            200: "#f3a09d",
            300: "#ea7b77",
            400: "#f55e54",
            500: "#fb513b",
            600: "#ec473a",
            700: "#da3e34",
            800: "#cc372d",
            900: "#bd2d21",
        },
        secondary: {
            50: "#e7ebf8",
            100: "#c3ccee",
            200: "#9babe2",
            300: "#718ad6",
            400: "#4f70ce",
            500: "#2457c5",
            600: "#1c4fbb",
            700: "#0b45af",
            800: "#003ba3",
            900: "#00288f",
        },
        info: {
            50: "#def5f6",
            100: "#aee5e9",
            200: "#7bd4dc",
            300: "#47c2ce",
            400: "#22b6c4",
            500: "#00a9bb",
            600: "#009aaa",
            700: "#038691",
            800: "#05727a",
            900: "#085051",
        },
        success: {
            50: "#f2f7e7",
            100: "#deecc3",
            200: "#c8df9c",
            300: "#b2d273",
            400: "#a1c953",
            500: "#90bf31",
            600: "#81b02a",
            700: "#81b02a",
            800: "#578816",
            900: "#326700",
        },
        warning: {
            50: "#FFFAF0",
            100: "#FEEBC8",
            200: "#FBD38D",
            300: "#F6AD55",
            400: "#ED8936",
            500: "#DD6B20",
            600: "#C05621",
            700: "#9C4221",
            800: "#7B341E",
            900: "#652B19",
        },
        error: {
            50: "#FFF5F5",
            100: "#FED7D7",
            200: "#FEB2B2",
            300: "#FC8181",
            400: "#F56565",
            500: "#E53E3E",
            600: "#C53030",
            700: "#9B2C2C",
            800: "#822727",
            900: "#63171B",
        },
        // Generated using https://materialpalettes.com/
        gray: {
            50: "#fafafa",
            100: "#f4f4f4",
            200: "#ededed",
            300: "#dedede",
            400: "#bbbbbb",
            500: "#9c9c9c",
            600: "#737373",
            700: "#5f5f5f",
            800: "#404040",
            900: "#1f1f1f",
        },
        gold: {
            50: "#fef9eb",
            100: "#fceecc",
            200: "#f9e4ad",
            300: "#f5da92",
            400: "#f1d280",
            500: "#edcb70",
            600: "#dcbb6a",
            700: "#c5a663",
            800: "#ad915e",
            900: "#837057",
        },
    },
    components: {
        NoomLoader: {
            baseStyle: {
                layer1: generateColorPalette("#EB7000"),
                layer2: generateColorPalette("#FFB81D"),
                layer3: generateColorPalette("#FFCF04"),
            },
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        CompassLoader: {
            sizes: {
                xs: { w: "1rem", h: "1rem" },
                sm: { w: "2rem", h: "2rem" },
                md: { w: "4rem", h: "4rem" },
                lg: { w: "7rem", h: "7rem" },
                xl: { w: "10rem", h: "10rem" },
                "2xl": { w: "15rem", h: "15rem" },
                "3xl": { w: "30rem", h: "30rem" },
            },
        },
        Popover: {
            variants: {
                responsive: {
                    popper: {
                        maxWidth: "unset",
                        width: "unset",
                    },
                },
            },
        },
    },
};
function extendInternalTheme(themeOverride) {
    return extendTheme$1(theme, internalTheme, themeOverride);
}
var index = extendTheme$1(theme, internalTheme);

const IconMap = {
    add: ChakraIcons.AddIcon,
    "arrow-back": ChakraIcons.ArrowBackIcon,
    "arrow-down": ChakraIcons.ArrowDownIcon,
    "arrow-forward": ChakraIcons.ArrowForwardIcon,
    "arrow-left": ChakraIcons.ArrowLeftIcon,
    "arrow-right": ChakraIcons.ArrowRightIcon,
    "arrow-up": ChakraIcons.ArrowUpIcon,
    "arrow-up-down": ChakraIcons.ArrowUpDownIcon,
    "at-sign": ChakraIcons.AtSignIcon,
    attachment: ChakraIcons.AttachmentIcon,
    bell: ChakraIcons.BellIcon,
    calendar: ChakraIcons.CalendarIcon,
    chat: ChakraIcons.ChatIcon,
    check: ChakraIcons.CheckIcon,
    "check-circle": ChakraIcons.CheckCircleIcon,
    "chevron-down": ChakraIcons.ChevronDownIcon,
    "chevron-left": ChakraIcons.ChevronLeftIcon,
    "chevron-right": ChakraIcons.ChevronRightIcon,
    "chevron-up": ChakraIcons.ChevronUpIcon,
    close: ChakraIcons.CloseIcon,
    copy: ChakraIcons.CopyIcon,
    delete: ChakraIcons.DeleteIcon,
    download: ChakraIcons.DownloadIcon,
    "drag-handle": ChakraIcons.DragHandleIcon,
    edit: ChakraIcons.EditIcon,
    email: ChakraIcons.EmailIcon,
    "external-link": ChakraIcons.ExternalLinkIcon,
    hamburger: ChakraIcons.HamburgerIcon,
    info: ChakraIcons.InfoIcon,
    "info-outline": ChakraIcons.InfoOutlineIcon,
    link: ChakraIcons.LinkIcon,
    lock: ChakraIcons.LockIcon,
    minus: ChakraIcons.MinusIcon,
    moon: ChakraIcons.MoonIcon,
    "not-allowed": ChakraIcons.NotAllowedIcon,
    phone: ChakraIcons.PhoneIcon,
    "plus-square": ChakraIcons.PlusSquareIcon,
    question: ChakraIcons.QuestionIcon,
    "question-outline": ChakraIcons.QuestionOutlineIcon,
    repeat: ChakraIcons.RepeatIcon,
    "repeat-clock": ChakraIcons.RepeatClockIcon,
    search: ChakraIcons.SearchIcon,
    "search-2": ChakraIcons.Search2Icon,
    settings: ChakraIcons.SettingsIcon,
    "small-add": ChakraIcons.SmallAddIcon,
    "small-close": ChakraIcons.SmallCloseIcon,
    spinner: ChakraIcons.SpinnerIcon,
    star: ChakraIcons.StarIcon,
    sun: ChakraIcons.SunIcon,
    time: ChakraIcons.TimeIcon,
    "triangle-down": ChakraIcons.TriangleDownIcon,
    "triangle-up": ChakraIcons.TriangleUpIcon,
    unlock: ChakraIcons.UnlockIcon,
    "up-down": ChakraIcons.UpDownIcon,
    view: ChakraIcons.ViewIcon,
    "view-off": ChakraIcons.ViewOffIcon,
    warning: ChakraIcons.WarningIcon,
    "warning-2": ChakraIcons.WarningTwoIcon,
};

const IconSize = Size;
/**
 * Use the `<Icon>` component to easily render `<svg>` icons.
 */
const Icon = (_a) => {
    var _b;
    var { className, icon, color, size, as, spacing = Spacing[2] } = _a, rest = __rest(_a, ["className", "icon", "color", "size", "as", "spacing"]);
    return (React.createElement(Icon$1, Object.assign({ fontSize: size, className: className, name: icon, color: color, mr: spacing, ml: spacing, as: (_b = as) !== null && _b !== void 0 ? _b : (icon ? IconMap[icon] : undefined) }, rest)));
};
Icon.displayName = "Icon";

const renderIcon = (iconName, size, extraProps) => {
    if (!iconName) {
        return undefined;
    }
    const iconProps = Object.assign({ h: "1em", w: "1em", m: 0, size }, extraProps);
    if (typeof iconName === "string") {
        return React.createElement(Icon, Object.assign({ icon: iconName }, iconProps));
    }
    return React.createElement(Icon, Object.assign({ as: iconName }, iconProps));
};

const ButtonSize = pick(Size, ["xs", "sm", "md", "lg", "xl"]);
const ButtonVariant = pick(Variant, [
    "outline",
    "unstyled",
    "ghost",
    "link",
    "solid",
]);
/**
 * The `Button` component represents a clickable button,
 *  used to submit forms or anywhere in a document for accessible, standard button functionality.
 */
const Button = forwardRef((_a, ref) => {
    var { className, children, size = Size.lg, type = "button", colorScheme, variantColor, iconSpacing = Spacing[2], leftIcon, rightIcon } = _a, rest = __rest(_a, ["className", "children", "size", "type", "colorScheme", "variantColor", "iconSpacing", "leftIcon", "rightIcon"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(Button$1, Object.assign({}, rest, { ref: ref, size: size, className: className, type: type, iconSpacing: iconSpacing, colorScheme: scheme, leftIcon: renderIcon(leftIcon, size), rightIcon: renderIcon(rightIcon, size) }), children));
});
Button.displayName = "Button";

const IconButton = forwardRef((_a, ref) => {
    var { icon, children, isRound, size } = _a, rest = __rest(_a, ["icon", "children", "isRound", "size"]);
    const a11yProps = {
        "aria-hidden": true,
        focusable: false,
    };
    return (React.createElement(Button, Object.assign({ px: 0, ref: ref, size: size }, rest), React.isValidElement(children) ? (React.cloneElement(children, a11yProps)) : (React.createElement(Icon, Object.assign({}, a11yProps, { icon: icon, m: 0, size: size })))));
});
IconButton.displayName = "IconButton";

const ButtonGroup = (_a) => {
    var { size, colorScheme, variantColor, variant, spacing = 2, children, isFullWidth } = _a, rest = __rest(_a, ["size", "colorScheme", "variantColor", "variant", "spacing", "children", "isFullWidth"]);
    const isAttached = spacing === Spacing[0];
    const validChildren = getValidChildren(children);
    const clones = validChildren.map((child, index) => {
        const isFirst = index === 0;
        const isLast = index === validChildren.length - 1;
        return cloneElement(child, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ size: size || child.props.size, colorScheme: child.props.colorScheme ||
                colorScheme ||
                child.props.variantColor ||
                variantColor, variant: child.props.variant || variant, _focus: { boxShadow: "outline", zIndex: 1 }, flex: isFullWidth ? 1 : undefined }, (!isLast && !isAttached && { mr: spacing })), (isFirst && isAttached && { roundedRight: 0 })), (isLast && isAttached && { roundedLeft: 0 })), (!isLast && isAttached && { borderRight: 0 })), (!isFirst && !isLast && isAttached && { rounded: 0 })));
    });
    return (React.createElement(Box, Object.assign({ display: isFullWidth ? "flex" : "inline-flex" }, rest), clones));
};
ButtonGroup.displayName = "ButtonGroup";

const CheckboxSize = pick(Size, ["sm", "md", "lg"]);
/**
 * Checkbox component isx used in forms when a user needs to select multiple values from several options.
 */
const Checkbox = forwardRef((props, ref) => {
    const { className, colorScheme, variantColor } = props, rest = __rest(props, ["className", "colorScheme", "variantColor"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(Checkbox$1, Object.assign({ ref: ref }, rest, { colorScheme: scheme, className: className })));
});
Checkbox.displayName = "Checkbox";

const FormControlSize = pick(Size, ["sm", "md", "lg"]);
const formSizeMap = {
    [FormControlSize.lg]: FormControlSize.md,
    [FormControlSize.md]: FormControlSize.md,
    [FormControlSize.sm]: FormControlSize.sm,
};
const FormControl = forwardRef((_a, ref) => {
    var { className, label, helper, error, children, isInvalid, size = FormControlSize.lg } = _a, rest = __rest(_a, ["className", "label", "helper", "error", "children", "isInvalid", "size"]);
    return (React.createElement(FormControl$1, Object.assign({}, rest, { className: className, isInvalid: Boolean(error) || isInvalid, position: "relative", ref: ref }),
        label && (React.createElement(FormLabel, { fontSize: formSizeMap[size], fontWeight: 500 }, label)),
        children,
        helper && !error && (React.createElement(FormHelperText, null, helper)),
        typeof error === "string" && (React.createElement(FormErrorMessage, { p: Spacing[1], position: "relative", top: "-5px" }, error))));
});
FormControl.displayName = "FormControl";

const CheckboxGroup = (props) => {
    var _a;
    const { className, colorScheme, variantColor = ColorScheme.primary, spacing = Spacing[2], options, children, label, name, error, helper, size, isInline, isWrap } = props, rest = __rest(props, ["className", "colorScheme", "variantColor", "spacing", "options", "children", "label", "name", "error", "helper", "size", "isInline", "isWrap"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const ListComponent = isWrap ? Wrap$1 : Stack$1;
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(CheckboxGroup$1, Object.assign({}, rest, { colorScheme: scheme, size: size }),
            React.createElement(ListComponent, { spacing: spacing, direction: isInline ? "row" : "column" }, (_a = options === null || options === void 0 ? void 0 : options.map(({ label: checkLabel, value, isDisabled, isChecked }) => (React.createElement(Checkbox, { name: name, value: value, isDisabled: isDisabled, key: checkLabel, size: size, isChecked: isChecked, colorScheme: scheme }, checkLabel)))) !== null && _a !== void 0 ? _a : children))));
};
CheckboxGroup.displayName = "CheckboxGroup";

/**
 * The Collapse component is used to create regions of content that can
 * expand/collapse with a simple animation. It helps to hide content that's
 * not immediately relevant to the user.
 *
 * This component leverages react-animate-height.
 */
const Collapse = forwardRef((_a, ref) => {
    var { isOpen } = _a, rest = __rest(_a, ["isOpen"]);
    return React.createElement(Collapse$1, Object.assign({}, rest, { ref: ref, animateOpacity: true, in: isOpen }));
});
Collapse.displayName = "Collapse";

/**
 * The description of the component
 */
const Container = forwardRef((_a, ref) => {
    var { className, children, centerHorizontal, centerVertical } = _a, rest = __rest(_a, ["className", "children", "centerHorizontal", "centerVertical"]);
    const styleProps = { display: "flex" };
    if (centerHorizontal) {
        styleProps.justifyContent = "center";
    }
    if (centerVertical) {
        styleProps.alignItems = "center";
    }
    return (React.createElement(Container$1, Object.assign({ ref: ref, className: className }, styleProps, rest), children));
});
Container.displayName = "Container";

const InputSize = pick(Size, ["sm", "md", "lg"]);
const InputVariant = pick(Variant, [
    "outline",
    "filled",
    "flushed",
    "unstyled",
]);
// Wrap components in an InputGroup only if there are multiple components
const ConditionalInputGroup = ({ children, size }) => {
    const hasExtraElements = Children.count(getValidChildren(children)) > 1;
    if (hasExtraElements) {
        return React.createElement(InputGroup, { size: size }, children);
    }
    return React.createElement(React.Fragment, null, children);
};
/**
 * `Input` component is a component that is used to get user input in a text field.
 */
const Input = forwardRef$1((_a, ref) => {
    var { className, colorScheme, variantColor, label, name, error, helper, leftElement, rightElement, leftAddonText, rightAddonText, size, type } = _a, rest = __rest(_a, ["className", "colorScheme", "variantColor", "label", "name", "error", "helper", "leftElement", "rightElement", "leftAddonText", "rightAddonText", "size", "type"]);
    const scheme = colorScheme || variantColor;
    const theme = useTheme();
    const focusBorderColor = useColorModeValue(`${scheme}.500`, transparentize(`${scheme}.500`, 0.5)(theme));
    const errorBorderColor = useColorModeValue(`${ColorScheme.error}.500`, transparentize(`${ColorScheme.error}.500`, 1)(theme));
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(ConditionalInputGroup, { size: size },
            leftElement && React.createElement(InputLeftElement, null, leftElement),
            leftAddonText && React.createElement(InputLeftAddon, null, leftAddonText),
            React.createElement(Input$1, Object.assign({}, rest, { ref: ref, name: name, size: size, type: type, colorScheme: scheme, focusBorderColor: focusBorderColor, errorBorderColor: errorBorderColor, className: className })),
            rightElement && (React.createElement(InputRightElement, null, rightElement)),
            rightAddonText && (React.createElement(InputRightAddon, null, rightAddonText)))));
});
Input.displayName = "Input";

const Popover = forwardRef((_a, ref) => {
    var { isLazy = true } = _a, props = __rest(_a, ["isLazy"]);
    return (React.createElement(Popover$1, Object.assign({ ref: ref }, props, { isLazy: isLazy })));
});

const BORDER_RADIUS = 4;

/* eslint-disable react/require-default-props */
const format = (date, dateFormat) => {
    if (!date) {
        return "";
    }
    if (!Array.isArray(date)) {
        return format$1(date, dateFormat);
    }
    return date.map((d) => format$1(d, dateFormat)).join(" - ");
};
const DatepickerPopover = ({ children, date, dateFormat, isClearable, isDisabled, isInline, isOpen, name, onDateChange, setPopoverOpen, variant, variantColor, colorScheme, }) => {
    const ref = useRef(null);
    const handleClear = () => {
        const value = Array.isArray(date) ? Array() : undefined;
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(value);
    };
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return isInline ? (React.createElement(Box, { borderColor: scheme === "error" ? "error.500" : "gray.500", borderRadius: isInline ? BORDER_RADIUS : 0, borderStyle: "solid", borderWidth: 1, width: "fit-content" }, children)) : (React.createElement(Popover, { closeOnBlur: true, initialFocusRef: ref, isLazy: true, isOpen: isOpen, onClose: () => setPopoverOpen(false), placement: "bottom-start", variant: "responsive" },
        React.createElement(PopoverTrigger, null,
            React.createElement(Input, { rightElement: isClearable &&
                    date && (React.createElement(IconButton, { onClick: handleClear, size: "xs", icon: "small-close" })), isDisabled: isDisabled, name: name, onChange: (e) => e.target.value, onClick: () => setPopoverOpen(!isOpen), value: format(date, dateFormat), variant: variant, colorScheme: scheme })),
        React.createElement(PopoverContent, { borderRadius: BORDER_RADIUS, ref: ref, shadow: "sm", width: "fit-content" },
            React.createElement(PopoverBody, { borderColor: "gray.300", borderRadius: BORDER_RADIUS, borderWidth: 1, padding: 0, width: "fit-content" }, children))));
};

/**
 * Friendly interface to create responsive grid layouts with ease. It renders a div element with display: grid.
 */
const SimpleGrid = forwardRef((_a, ref) => {
    var { className, spacing = Spacing[2], columns, children } = _a, rest = __rest(_a, ["className", "spacing", "columns", "children"]);
    return (React.createElement(SimpleGrid$1, Object.assign({}, rest, { ref: ref, className: className, spacing: spacing, columns: columns }), children));
});
SimpleGrid.displayName = "SimpleGrid";

/**
 * Headings are used for rendering headlines.
 */
const Heading = forwardRef((_a, ref) => {
    var { fontWeight = 300, colorScheme, variantColor, color } = _a, rest = __rest(_a, ["fontWeight", "colorScheme", "variantColor", "color"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const textColor = scheme ? `${scheme}.500` : color;
    return (React.createElement(Heading$1, Object.assign({}, rest, { ref: ref, fontWeight: fontWeight, color: textColor })));
});
const H1 = forwardRef((props, ref) => {
    return React.createElement(Heading, Object.assign({}, props, { ref: ref, as: "h1", size: Size.xxl }));
});
const H2 = forwardRef((props, ref) => {
    return React.createElement(Heading, Object.assign({}, props, { ref: ref, as: "h2", size: Size.xl }));
});
const H3 = forwardRef((props, ref) => {
    return React.createElement(Heading, Object.assign({}, props, { ref: ref, as: "h3", size: Size.lg }));
});
const H4 = forwardRef((props, ref) => {
    return React.createElement(Heading, Object.assign({}, props, { ref: ref, as: "h4", size: Size.md }));
});
const H5 = forwardRef((props, ref) => {
    return React.createElement(Heading, Object.assign({}, props, { ref: ref, as: "h5", size: Size.sm }));
});
const H6 = forwardRef((props, ref) => {
    return React.createElement(Heading, Object.assign({}, props, { ref: ref, as: "h6", size: Size.xs }));
});
Heading.displayName = "Heading";
H1.displayName = "H1";
H2.displayName = "H2";
H3.displayName = "H3";
H4.displayName = "H4";
H5.displayName = "H5";
H6.displayName = "H6";

/**
 * Stack is a layout utility component that makes it easy to stack elements together and apply a space between them.
 * It leverages power of css flex-box to quickly align an justify content.
 */
const Stack = forwardRef((_a, ref) => {
    var { className, shouldWrapChildren = true } = _a, rest = __rest(_a, ["className", "shouldWrapChildren"]);
    return (React.createElement(Stack$1, Object.assign({}, rest, { ref: ref, className: className, shouldWrapChildren: shouldWrapChildren })));
});
Stack.displayName = "Stack";

/**
 * Text is the used to render text and paragraphs within an interface. It renders a `<span>` tag by default.
 */
const Text = forwardRef((_a, ref) => {
    var { colorScheme, variantColor, color, as = "span", size } = _a, rest = __rest(_a, ["colorScheme", "variantColor", "color", "as", "size"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const c = scheme ? `${scheme}.500` : color;
    const textColor = useColorModeValue$1(c !== null && c !== void 0 ? c : "black", transparentize(c !== null && c !== void 0 ? c : "black", 0.5)(theme));
    return (React.createElement(Text$1, Object.assign({}, rest, { ref: ref, as: as, color: textColor, fontSize: size })));
});
Text.displayName = "Text";

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

const TimePickerButton = (_a) => {
    var { containerRef, handleTimeChange, date = undefined, value: timeValue, variantColor, colorScheme } = _a, props = __rest(_a, ["containerRef", "handleTimeChange", "date", "value", "variantColor", "colorScheme"]);
    const label = format$1(timeValue, "p");
    const value = format$1(timeValue, "HH:mm");
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const timePart = date && !Array.isArray(date) ? format$1(date, "HH:mm") : undefined;
    const isSelected = value === timePart;
    const ref = useRef(null);
    const scrollIntoView = useCallback(() => {
        var _a, _b, _c, _d, _e;
        const position = ((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0) -
            ((_d = (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 0) / 2;
        (_e = containerRef.current) === null || _e === void 0 ? void 0 : _e.scrollTo(0, Math.max(position, 0));
    }, [containerRef, ref]);
    const previousTime = usePrevious(timePart);
    useEffect(() => {
        if (isSelected && previousTime !== timePart) {
            scrollIntoView();
        }
    }, [previousTime, timePart, isSelected, scrollIntoView]);
    const handleButtonClick = () => {
        handleTimeChange === null || handleTimeChange === void 0 ? void 0 : handleTimeChange(value);
        scrollIntoView();
    };
    return (React.createElement(Button, Object.assign({}, props, { fontWeight: isSelected ? "bold" : "normal", isFullWidth: true, key: value, onClick: handleButtonClick, ref: ref, size: "xs", variant: isSelected ? "solid" : "ghost", colorScheme: isSelected ? scheme : "gray" }), label));
};

const getTimeOptions = (interval) => {
    const options = [];
    const today = new Date();
    let time = startOfDay(today);
    while (time.getDate() === today.getDate()) {
        options.push(time);
        time = addMinutes(time, interval);
    }
    return options;
};
const Timepicker = ({ date, handleTimeChange, timeInterval, variantColor, colorScheme, }) => {
    const timePickerRef = useRef(null);
    const timeOptions = getTimeOptions(timeInterval !== null && timeInterval !== void 0 ? timeInterval : 60);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const headerBgColor = useColorModeValue$1(`${scheme}.200`, transparentize(`${scheme}.200`, 0.5)(theme));
    const varColor = scheme === "error" ? "error.500" : "gray.500";
    return (React.createElement(Box, { borderLeftStyle: "solid", borderLeftColor: varColor, borderLeftWidth: 1 },
        React.createElement(Box, { bg: headerBgColor, borderBottomStyle: "solid", borderBottomColor: varColor, borderBottomWidth: 1, borderTopRightRadius: BORDER_RADIUS, textAlign: "center" },
            React.createElement(Heading, { py: Spacing[2], size: "xs", textAlign: "center", textTransform: "uppercase" }, "Time")),
        React.createElement(Stack, { height: 201, overflow: "scroll", padding: Spacing[1], spacing: 1, ref: timePickerRef, position: "relative" }, timeOptions.map((t) => (React.createElement(TimePickerButton, { containerRef: timePickerRef, date: date, handleTimeChange: handleTimeChange, value: t, colorScheme: scheme }))))));
};

/* eslint-disable react/require-default-props */
const isInRange = (current, hoveredDate, date) => {
    if (!Array.isArray(date) || !date.length) {
        return false;
    }
    const currentTime = current.getTime();
    const firstSelected = date[0].getTime();
    if (date.length === 2) {
        const secondSelected = date[1].getTime();
        const inRange = firstSelected < currentTime && secondSelected > currentTime;
        return inRange;
    }
    if (hoveredDate) {
        const first = firstSelected < currentTime;
        const second = hoveredDate.getTime() >= currentTime;
        const third = currentTime < firstSelected;
        const fourth = currentTime >= hoveredDate.getTime();
        return hoveredDate && ((first && second) || (third && fourth));
    }
    return false;
};
function Calendar({ calendars, date = undefined, dayNames, getBackProps, getDateProps, getForwardProps, isInline, isPickingTime = false, monthNames, onTimeChanged, timeInterval, variantColor = ColorScheme.gray, colorScheme, }) {
    var _a;
    const [hoveredDate, setHoveredDate] = useState(undefined);
    const handleTimeChange = (value) => {
        onTimeChanged === null || onTimeChanged === void 0 ? void 0 : onTimeChanged(value);
    };
    if (!(calendars === null || calendars === void 0 ? void 0 : calendars.length)) {
        return null;
    }
    const scheme = (_a = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor) !== null && _a !== void 0 ? _a : "gray";
    const varColor = scheme === "error" ? "error.500" : "gray.500";
    const theme = useTheme();
    const headerBgColor = useColorModeValue(`${scheme}.200`, transparentize(`${scheme}.200`, 0.5)(theme));
    const dayButtonColor = useColorModeValue("blackAlpha.600", "whiteAlpha.900");
    const dayButtonColorAlt = useColorModeValue("blackAlpha.900", "whiteAlpha.600");
    const dayButtonColorSelected = useColorModeValue("white", "black");
    return (React.createElement(Stack, { isInline: true, spacing: 0 },
        React.createElement(Stack, { onMouseLeave: () => setHoveredDate(undefined), width: 250, className: "datepicker-calendar" }, calendars.map((calendar) => (React.createElement(Stack, { shouldWrapChildren: false, key: `${calendar.month}${calendar.year}`, spacing: 0 },
            React.createElement(Stack, { borderTopLeftRadius: isInline ? BORDER_RADIUS : 0, borderTopRightRadius: isInline && !isPickingTime ? BORDER_RADIUS : 0, bg: headerBgColor, display: "flex", isInline: true, shouldWrapChildren: false, alignItems: "center" },
                React.createElement(Button, Object.assign({}, getBackProps({ calendars }), { flexGrow: 0, padding: 0, size: "sm", variant: "ghost" }),
                    React.createElement(Icon, { width: 30, height: 30, icon: "chevron-left" })),
                React.createElement(Heading, { flexGrow: 1, fontWeight: "bold", size: "sm", textAlign: "center" },
                    monthNames[calendar.month],
                    " ",
                    calendar.year),
                React.createElement(Button, Object.assign({}, getForwardProps({ calendars }), { flexGrow: 0, padding: 0, size: "sm", variant: "ghost" }),
                    React.createElement(Icon, { width: 30, height: 30, icon: "chevron-right" }))),
            React.createElement(SimpleGrid, { columns: 7, marginX: Spacing[1], spacing: 0, textAlign: "center" }, dayNames.map((day) => (React.createElement(Box, { bg: headerBgColor, borderBottomColor: varColor, borderBottomStyle: "solid", borderBottomWidth: 1, key: `${calendar.month}${calendar.year}${day}` },
                React.createElement(Text, { fontSize: "xs" }, day.substring(0, 1)))))),
            React.createElement(SimpleGrid, { columns: 7, padding: Spacing[1], spacing: 1, textAlign: "center" }, calendar.weeks.map((week, weekIndex) => week.map((dateObj, index) => {
                const { date: btnDate, today, prevMonth, nextMonth, selected, selectable, } = dateObj;
                const key = `${calendar.month}${calendar.year}${weekIndex}${index}`;
                const notThisMonth = prevMonth || nextMonth;
                const inRange = isInRange(btnDate, hoveredDate, date);
                let color = notThisMonth ? dayButtonColorAlt : dayButtonColor;
                if (selected || inRange) {
                    color = dayButtonColorSelected;
                }
                return (React.createElement(Button, Object.assign({}, getDateProps({ dateObj }), { onMouseEnter: () => Array.isArray(date) &&
                        (!date.length || date.length === 1) &&
                        setHoveredDate(btnDate), color: color, isDisabled: !selectable, fontWeight: today || selected || inRange ? "bold" : "normal", key: key, size: "xs", variant: selected || inRange ? "solid" : "ghost", colorScheme: selected || inRange ? scheme : "gray" }), btnDate.getDate()));
            }))))))),
        isPickingTime && !Array.isArray(date) && (React.createElement(Timepicker, { date: date, handleTimeChange: handleTimeChange, timeInterval: timeInterval, colorScheme: scheme }))));
}

/* eslint-disable react/require-default-props */
const MONTH_NAMES_DEFAULT = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const DAY_NAMES_DEFAULT = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const DATE_FORMAT_DEFAULT = "P";
const DATETIME_FORMAT = "Pp";
const handleChange = (selectedDate, setIsOpen, date, onDateChange) => {
    if (selectedDate.selectable && selectedDate.date !== null) {
        // preserve time when changing date
        const withTime = date
            ? setHours(setMinutes(selectedDate.date, getMinutes(date)), getHours(date))
            : selectedDate.date;
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(withTime);
        setIsOpen(false);
    }
};
const handleRangeChange = (selectedDate, setIsOpen, dates, onDateChange) => {
    if (!selectedDate.selectable) {
        return;
    }
    const dateTime = selectedDate.date.getTime();
    const newDates = [...dates];
    if (dates.length) {
        if (dates.length === 1) {
            const firstTime = dates[0].getTime();
            if (firstTime < dateTime) {
                newDates.push(selectedDate.date);
            }
            else {
                newDates.unshift(selectedDate.date);
            }
            onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDates);
            setIsOpen(false);
        }
        else if (newDates.length === 2) {
            onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange([selectedDate.date]);
        }
    }
    else {
        newDates.push(selectedDate.date);
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDates);
    }
};
const setHoursAndMinutes = (date, time) => {
    if (!time) {
        return undefined;
    }
    const minutes = time.substring(3, 5);
    const hours = time.substring(0, 2);
    const withMinutes = setMinutes(date, parseInt(minutes, 10));
    return setHours(withMinutes, parseInt(hours, 10));
};
const Datepicker = ({ date, dateFormat, dayNames = DAY_NAMES_DEFAULT, isClearable = false, isDisabled = false, isInline = false, isPickingTime = false, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
isSelectingRange = false, maxDate, minDate, monthNames = MONTH_NAMES_DEFAULT, name, onDateChange, timeInterval, variant, variantColor, colorScheme, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const format = (dateFormat !== null && dateFormat !== void 0 ? dateFormat : isPickingTime) ? DATETIME_FORMAT : DATE_FORMAT_DEFAULT;
    const handleSetIsOpen = (state) => {
        if (isPickingTime) {
            return;
        }
        setIsOpen(state);
    };
    const { calendars, getBackProps, getForwardProps, getDateProps } = useDayzed({
        minDate,
        maxDate,
        showOutsideDays: true,
        onDateSelected: (selectedDate) => Array.isArray(date)
            ? handleRangeChange(selectedDate, handleSetIsOpen, date, onDateChange)
            : handleChange(selectedDate, handleSetIsOpen, date, onDateChange),
        selected: date,
    });
    const handleTimeChange = (time) => {
        var _a;
        if (isPickingTime && !isSelectingRange && !Array.isArray(date)) {
            const dateWithTime = setHoursAndMinutes(date !== null && date !== void 0 ? date : new Date(), time);
            if (dateWithTime) {
                (_a = onDateChange) === null || _a === void 0 ? void 0 : _a(dateWithTime);
                handleSetIsOpen(false);
            }
        }
    };
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(DatepickerPopover, { date: date, dateFormat: format, isClearable: isClearable, isDisabled: isDisabled, isInline: isInline, isOpen: isOpen, name: name, onDateChange: onDateChange, setPopoverOpen: setIsOpen, variant: variant, colorScheme: scheme },
        React.createElement(Calendar, { calendars: calendars, monthNames: monthNames, dayNames: dayNames, date: date, getBackProps: getBackProps, getDateProps: getDateProps, getForwardProps: getForwardProps, isInline: isInline, isDisabled: isDisabled, isPickingTime: isPickingTime, timeInterval: timeInterval, onTimeChanged: handleTimeChange, colorScheme: scheme })));
};

/**
 * Dividers are used to visually separate content in a list or group.
 */
const Divider = forwardRef((_a, ref) => {
    var { orientation } = _a, rest = __rest(_a, ["orientation"]);
    return React.createElement(Divider$1, Object.assign({ ref: ref, orientation: orientation }, rest));
});
Divider.displayName = "Divider";

/**
 * Simple input type="file" component that is represented using a Button.
 */
const FileInputButton = (_a) => {
    var { onChange, isLoading, accept, multiple, children } = _a, buttonProps = __rest(_a, ["onChange", "isLoading", "accept", "multiple", "children"]);
    const inputRef = useRef(null);
    function handleClick() {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }
    function handleChange() {
        var _a;
        const files = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files;
        if (files && onChange) {
            onChange(files);
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: inputRef, type: "file", accept: accept, multiple: multiple, style: { display: "none" }, onChange: handleChange }),
        React.createElement(Button, Object.assign({ isLoading: isLoading, onClick: handleClick }, buttonProps), children)));
};
FileInputButton.displayName = "FileInputButton";

const Image = (_a) => {
    var { alt, fallbackSrc, htmlHeight, htmlWidth, ignoreFallback, onError, onLoad, src } = _a, boxProps = __rest(_a, ["alt", "fallbackSrc", "htmlHeight", "htmlWidth", "ignoreFallback", "onError", "onLoad", "src"]);
    return (React.createElement(Image$1, Object.assign({ alt: alt, fallbackSrc: fallbackSrc, htmlHeight: htmlHeight, htmlWidth: htmlWidth, ignoreFallback: ignoreFallback, onError: onError, onLoad: onLoad, src: src }, boxProps)));
};
Image.displayName = "Image";

/**
 * Semantic component to render a keyboard shortcut within an application.
 *
 * @example
 *
 * ```jsx
 * <Kbd>⌘ + T</Kbd>
 * ```
 *
 */
const Kbd = forwardRef((_a, ref) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (React.createElement(Kbd$1, Object.assign({ ref: ref, className: className }, rest), children));
});
Kbd.displayName = "Kbd";

/**
 * The link component. <a>.
 */
const Link = forwardRef((_a, ref) => {
    var { className, children, color, colorScheme, variantColor = ColorScheme.primary } = _a, rest = __rest(_a, ["className", "children", "color", "colorScheme", "variantColor"]);
    const scheme = colorScheme || variantColor;
    const formattedColor = color !== null && color !== void 0 ? color : `${scheme}.500`;
    return (React.createElement(Link$1, Object.assign({ ref: ref, className: className, color: formattedColor, colorScheme: scheme }, rest), children));
});
Link.displayName = "Link";

/**
 * The list component. <ul> or <ol>.
 */
const List = forwardRef((_a, ref) => {
    var { className, isOrdered, children } = _a, rest = __rest(_a, ["className", "isOrdered", "children"]);
    const Component = isOrdered ? OrderedList : UnorderedList;
    return (React.createElement(Component, Object.assign({ className: className }, rest, { ref: ref }), children));
});
List.displayName = "List";
/**
 * The list item component. <li>.
 */
const ListItem = forwardRef((props, ref) => {
    return React.createElement(ListItem$1, Object.assign({}, props, { ref: ref }));
});
ListItem.displayName = "ListItem";

const LoaderSize = pick(Size, ["xs", "sm", "md", "lg", "xl"]);
/**
 * Loaders provide a visual cue that an action is processing awaiting a course of change or a result.
 */
const Loader$2 = forwardRef((_a, ref) => {
    var { colorScheme, variantColor, speed = "0.65s" } = _a, rest = __rest(_a, ["colorScheme", "variantColor", "speed"]);
    const scheme = colorScheme || variantColor;
    const emptyColor = useColorModeValue$1("gray.300", "gray.600");
    return (React.createElement(Spinner, Object.assign({}, rest, { ref: ref, speed: speed, color: scheme && `${scheme}.500`, emptyColor: emptyColor, thickness: "4px" })));
});
Loader$2.displayName = "Loader";

const SunLayer1 = (props) => (React.createElement(chakra.svg, Object.assign({ viewBox: "0 0 76 76" }, props),
    React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { id: "Bounding-Box", x: "0", y: "0", width: "76", height: "76" }),
        React.createElement("g", { id: "Sun", transform: "translate(5.000000, 5.000000)" },
            React.createElement("path", { d: "M44.4236132,3.24158795 C45.4912204,6.73238518 49.2672359,8.88662814 52.8150604,8.03090741 C56.362885,7.17382841 58.5945373,9.38376113 57.7727785,12.9397561 C56.9510198,16.4971094 59.143282,20.2514143 62.6449251,21.2837123 C66.1465681,22.3160103 66.97376,25.34499 64.4840347,28.0140237 C61.9943094,30.6830574 62.0160419,35.0309336 64.5315745,37.6755181 C67.0471071,40.3201026 66.2497973,43.3572321 62.7590205,44.4234872 C59.2682436,45.4911007 57.112655,49.2671382 57.969729,52.8149835 C58.8254447,56.3628287 56.6168832,58.5944941 53.0595506,57.7727305 C49.5035764,56.9523252 45.7492934,59.1446002 44.7170014,62.6449055 C43.6847094,66.146569 40.6557474,66.9737657 37.9867293,64.4840259 C35.316353,61.9942861 30.9698604,62.0160187 28.323933,64.5315659 C25.6793639,67.0471132 22.6436105,66.2497988 21.5760033,62.7590016 C20.5097543,59.2682043 16.7337389,57.1126031 13.184556,57.9696821 C9.63673147,58.8267611 7.40643746,56.6168284 8.22683794,53.0608334 C9.04859669,49.5034801 6.8563345,45.7491752 3.35469141,44.7168772 C-0.145593397,43.6845792 -0.972785266,40.6555995 1.51558174,37.9865658 C4.00530702,35.3175321 3.98493283,30.9696559 1.46804197,28.3250714 C-1.04749061,25.6804869 -0.248822596,22.6433575 3.24059598,21.575744 C6.73137283,20.5094888 8.8869615,16.7334513 8.03124577,13.185606 C7.17417177,9.63640248 9.38409159,7.40609546 12.9400658,8.22785901 C16.4960401,9.04826427 20.2516813,6.85598928 21.2839733,3.35568404 C22.3162653,-0.145979482 25.3452273,-0.973176179 28.0142454,1.51656363 C30.6832635,4.00630345 35.0311144,3.98457086 37.6756835,1.46902359 C40.3202525,-1.04788196 43.3573642,-0.249209283 44.4236132,3.24158795", id: "Fill-1", fill: props.fill })))));
const SunLayer2 = (props) => (React.createElement(chakra.svg, Object.assign({ viewBox: "0 0 76 76" }, props),
    React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { id: "Bounding-Box", x: "0", y: "0", width: "76", height: "76" }),
        React.createElement("g", { id: "Sun", transform: "translate(5.000000, 5.000000)" },
            React.createElement("path", { d: "M36.1286797,7.59114605 C37.668449,10.0816192 41.0370369,10.9830116 43.6138217,9.59530571 C46.1906065,8.20759981 48.3714897,9.46653537 48.4591634,12.3926359 C48.5468371,15.3173665 51.0140298,17.7818116 53.9387696,17.869485 C56.8648792,17.9571584 58.1238188,20.1366649 56.7374784,22.7148115 C55.351138,25.2915882 56.2539032,28.6601656 58.7443842,30.1971903 C61.2348651,31.7355849 61.2348651,34.253456 58.7443842,35.7932205 C56.2552731,37.3316151 55.3538778,40.7001924 56.7415881,43.2769691 C58.1292984,45.8537458 56.8703588,48.0346222 53.9442492,48.1222956 C51.0181395,48.2113389 48.5536866,50.6771539 48.4673828,53.6018845 C48.3797091,56.527985 46.2001958,57.7869206 43.6220411,56.4005846 C41.0438864,55.0142486 37.6766684,55.9170109 36.138269,58.407484 C34.5998695,60.8979572 32.0819905,60.8979572 30.5435911,58.4088539 C29.0038218,55.9183808 25.6366038,55.0169884 23.059819,56.4046943 C20.4816643,57.7924002 18.302151,56.5334646 18.2131074,53.6073641 C18.1254337,50.6826335 15.6596109,48.2168185 12.7335012,48.130515 C9.80876142,48.0428416 8.548452,45.8633351 9.93616226,43.2851885 C11.3225026,40.7084118 10.4197375,37.3398344 7.92925651,35.8014398 C5.43877551,34.2644151 5.43877551,31.746544 7.92788661,30.2067795 C10.4169977,28.6683849 11.3197628,25.2998076 9.93205256,22.7230309 C8.5443423,20.1462542 9.80328181,17.9653778 12.7280216,17.8777044 C15.6541313,17.7886611 18.1185841,15.3228461 18.2062578,12.3981155 C18.2925616,9.47201496 20.4734449,8.2130794 23.0502297,9.5994154 C25.6283844,10.9857514 28.9956024,10.0829891 30.5340018,7.59251595 C32.0724012,5.10204277 34.5902802,5.10204277 36.1286797,7.59114605", id: "Fill-2", fill: props.fill })))));
const SunLayer3 = (props) => (React.createElement(chakra.svg, Object.assign({ viewBox: "0 0 76 76" }, props),
    React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { id: "Bounding-Box", x: "0", y: "0", width: "76", height: "76" }),
        React.createElement("g", { id: "Sun", transform: "translate(5.000000, 5.000000)" },
            React.createElement("path", { d: "M30.0666954,14.4315679 C31.6443242,15.8734138 34.188624,15.835399 35.7214492,14.3473923 C37.2556321,12.8593856 39.0369135,13.3087745 39.6818134,15.3466377 C40.3267133,17.3831432 42.5505996,18.6226962 44.6224254,18.1013508 C46.6942511,17.5786477 48.0125623,18.8589309 47.5523074,20.9456702 C47.0920526,23.0324095 48.3981445,25.2169011 50.4536781,25.8006994 C52.507854,26.3858553 53.010197,28.1535421 51.5683367,29.7297974 C50.1264763,31.3074103 50.1644914,33.8516845 51.6525131,35.385852 C53.1405347,36.9186619 52.6911413,38.701283 50.6546153,39.3461764 C48.6180894,39.9910698 47.3771662,42.2135762 47.8998745,44.2853812 C48.4212252,46.3571861 47.1422869,47.675484 45.0555266,47.2152338 C42.9687663,46.7563412 40.7828951,48.0610624 40.199091,50.1165753 C39.6152868,52.1720882 37.8475823,52.6730686 36.2699535,51.2325803 C34.6936824,49.7907344 32.1480249,49.8287492 30.6151997,51.3153982 C29.0823745,52.8034049 27.2997354,52.3553737 26.6548355,50.3175105 C26.0099356,48.281005 23.7874069,47.041452 21.7155812,47.5627974 C19.6437554,48.0855005 18.3240866,46.8052173 18.7843415,44.718478 C19.2445963,42.6317387 17.939862,40.4472471 15.8843285,39.8634488 C13.8287949,39.2782929 13.3264518,37.5106061 14.7683122,35.9343508 C16.2101726,34.3567379 16.1721575,31.8124637 14.6841358,30.2782962 C13.1961142,28.7454864 13.6455076,26.9628652 15.6833912,26.3179718 C17.7199172,25.6730784 18.9594827,23.450572 18.438132,21.378767 C17.9154237,19.3069621 19.1957197,17.9886642 21.28248,18.4475568 C23.3692403,18.907807 25.5537538,17.6030858 26.1375579,15.5475729 C26.721362,13.49206 28.4904243,12.9910796 30.0666954,14.4315679", id: "Fill-3", fill: props.fill })))));
const spin$1 = keyframes({
    "0%": {
        transform: "rotate(0deg)",
    },
    "100%": {
        transform: "rotate(360deg)",
    },
});
/**
 * Loaders provide a visual cue that an action is processing awaiting a course of change or a result. In a shape of a spinning noom logo.
 */
const Loader$1 = (_a) => {
    var { speed = "30s", size = "md", colorScheme, variantColor = ColorScheme.primary } = _a, rest = __rest(_a, ["speed", "size", "colorScheme", "variantColor"]);
    const theme = useTheme();
    const [timeValue, timeUnit] = splitTimeUnit(speed);
    const themeStyle = theme.components.NoomLoader.sizes[size];
    const sunStyle = Object.assign(Object.assign({}, themeStyle), { top: 0, left: 0, position: "absolute" });
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    // Quick trick to get a lot of color variations
    const colors = scheme === ColorScheme.primary
        ? [
            theme.components.NoomLoader.baseStyle.layer1[500],
            theme.components.NoomLoader.baseStyle.layer2[500],
            theme.components.NoomLoader.baseStyle.layer3[500],
        ]
        : [
            theme.colors[scheme][600],
            theme.colors[scheme][400],
            theme.colors[scheme][200],
        ];
    return (React.createElement(chakra.div, Object.assign({ borderRadius: "50%", position: "relative" }, themeStyle, rest, { label: "Loading..." }),
        React.createElement(SunLayer1, Object.assign({}, sunStyle, { fill: colors[0], animation: `${spin$1} ${timeValue}${timeUnit} linear infinite` })),
        React.createElement(SunLayer2, Object.assign({}, sunStyle, { fill: colors[1], animation: `${spin$1} ${timeValue / 2}${timeUnit} linear infinite` })),
        React.createElement(SunLayer3, Object.assign({}, sunStyle, { fill: colors[2], animation: `${spin$1} ${timeValue / 4}${timeUnit} linear infinite` }))));
};
Loader$1.displayName = "Loader";

const Circle = (props) => (React.createElement(chakra.div, Object.assign({}, props, { borderRadius: "full", borderStyle: "solid", position: "absolute" })));
const spin = keyframes({
    "0%": {
        transform: "rotate(0deg)",
    },
    "50%": {
        transform: "rotate(-180deg)",
    },
    "100%": {
        transform: "rotate(-360deg)",
    },
});
/**
 * Loaders provide a visual cue that an action is processing awaiting a course of change or a result. In a shape of a spinning noom logo.
 */
const Loader = (_a) => {
    var { size = "md", speed = "2.5s", color = CompassColor.offWhite } = _a, rest = __rest(_a, ["size", "speed", "color"]);
    const theme = useTheme();
    const themeStyle = theme.components.CompassLoader.sizes[size];
    const bigSize = `78%`;
    const smallSize = `32%`;
    const borderWidthBig = `calc(${themeStyle.h} * 0.12)`;
    const borderWidthSmall = `calc(${themeStyle.h} * 0.09)`;
    return (React.createElement(chakra.div, Object.assign({ borderRadius: "50%", position: "relative" }, themeStyle, rest, { animation: `${spin} ${speed} cubic-bezier(0.5, 0, 0.5, 1) infinite` }),
        React.createElement(Circle, { bgColor: "transparent", borderColor: color, borderWidth: borderWidthBig, h: bigSize, w: bigSize, bottom: 0, left: 0 }),
        React.createElement(Circle, { bgColor: "transparent", borderColor: color, borderWidth: borderWidthSmall, h: smallSize, w: smallSize, top: 0, right: 0 })));
};
Loader.displayName = "Loader";

function getSize(el) {
    var _a, _b;
    return {
        height: (_a = el === null || el === void 0 ? void 0 : el.offsetHeight) !== null && _a !== void 0 ? _a : 0,
        width: (_b = el === null || el === void 0 ? void 0 : el.offsetWidth) !== null && _b !== void 0 ? _b : 0,
    };
}
function useComponentSize(ref) {
    const [size, setSize] = useState(getSize(ref.current));
    const handleResize = useCallback(() => {
        setSize(getSize(ref.current));
    }, [ref]);
    useLayoutEffect(() => {
        if (!ref.current) {
            return undefined;
        }
        handleResize();
        const resizeObserver = new ResizeObserver(() => {
            handleResize();
        });
        resizeObserver.observe(ref.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, [ref, handleResize]);
    return size;
}

const defaultStyles = {
    display: "flex",
    w: "100vw",
    h: "100vh",
    position: "relative",
    flexDir: "column",
    alignItems: "center",
    justifyContent: "center",
    color: CompassColor.offWhite,
    background: `url('${Background}')`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    fontFamily: "Untitled Sans",
    fontWeight: 500,
};
/**
 * Default loader view for web apps
 * @param text - text beneath the loader
 * @param quote - quote on the bottom of the view
 */
function LoaderView(_a) {
    var { className, text = "Loading...", quote = { text: "Mother Father Cheers", author: "Saeju Jeong" } } = _a, styles = __rest(_a, ["className", "text", "quote"]);
    const loaderSize = useBreakpointValue({
        base: "lg",
        sm: "lg",
        md: "xl",
    });
    const bgColor = useColorModeValue("#00000020", "#FFFFFF20");
    const compassColor = useColorModeValue(CompassColor.offWhite, CompassColor.grey4);
    return (React.createElement(Box, Object.assign({ className: className }, defaultStyles, styles),
        React.createElement(Box, { flex: 1, paddingTop: 10, width: "100%", paddingBottom: 5, paddingX: 10, background: bgColor, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" },
            React.createElement(Loader, { size: loaderSize, mb: 10, color: compassColor }),
            React.createElement(H1, { fontFamily: "Untitled Sans", fontWeight: 500, color: compassColor }, text)),
        quote && (React.createElement(Box, { zIndex: 1, fontWeight: 300, position: "absolute", bottom: "0", padding: 2, textAlign: "center", width: "100%", background: bgColor, color: compassColor, fontFamily: "Brown LL" },
            "\"",
            quote.text,
            "\" - ",
            quote.author))));
}
LoaderView.displayName = "LoaderView";

const MenuButton = React.forwardRef((_a, ref) => {
    var { className, size } = _a, props = __rest(_a, ["className", "size"]);
    return (React.createElement(MenuButton$1, Object.assign({ ref: ref, className: className, size: size }, props)));
});
const Menu = (_a) => {
    var { isLazy = true } = _a, rest = __rest(_a, ["isLazy"]);
    return React.createElement(Menu$1, Object.assign({}, rest, { isLazy: isLazy }));
};
Menu.displayName = "Menu";
MenuButton.displayName = "MenuButton";
MenuList.displayName = "MenuList";
MenuItem.displayName = "MenuItem";
MenuGroup.displayName = "MenuGroup";
MenuDivider.displayName = "MenuDivider";
MenuOptionGroup.displayName = "MenuOptionGroup";
MenuItemOption.displayName = "MenuItemOption";

Modal.displayName = "Modal";
ModalOverlay.displayName = "ModalOverlay";
ModalContent.displayName = "ModalContent";
ModalHeader.displayName = "ModalHeader";
ModalFooter.displayName = "ModalFooter";
ModalBody.displayName = "ModalBody";
ModalCloseButton.displayName = "ModalCloseButton";

/**
 * A simple dialog to mimic native `window.alert` behavior.
 */
const ModalAlert = (_a) => {
    var { className, titleText = "Alert", buttonText = "OK", variantColor, colorScheme, children, onClose } = _a, rest = __rest(_a, ["className", "titleText", "buttonText", "variantColor", "colorScheme", "children", "onClose"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(Modal, Object.assign({}, rest, { onClose: onClose }),
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                React.createElement(Text, { colorScheme: scheme }, titleText)),
            React.createElement(ModalBody, null, children),
            React.createElement(ModalFooter, null,
                React.createElement(ButtonGroup, { spacing: Spacing[2] },
                    React.createElement(Button, { variant: Variant.solid, size: Size.md, colorScheme: scheme, onClick: onClose }, buttonText))))));
};
ModalAlert.displayName = "ModalAlert";

/**
 * A simple dialog to mimic native `window.confirm` behavior.
 */
const ModalConfirm = (_a) => {
    var { className, titleText = "Confirm", confirmButtonText = "Yes", cancelButtonText = "No", variantColor, colorScheme, children, onClose, onConfirm } = _a, rest = __rest(_a, ["className", "titleText", "confirmButtonText", "cancelButtonText", "variantColor", "colorScheme", "children", "onClose", "onConfirm"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme$1();
    const headerColor = useColorModeValue(`${scheme}.500`, transparentize(`${scheme}.500`, 0.75)(theme));
    return (React.createElement(Modal, Object.assign({}, rest, { onClose: onClose }),
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                React.createElement(Text, { color: headerColor, colorScheme: undefined }, titleText)),
            React.createElement(ModalBody, null, children),
            React.createElement(ModalFooter, null,
                React.createElement(ButtonGroup, { spacing: Spacing[2] },
                    React.createElement(Button, { variant: Variant.solid, size: Size.md, colorScheme: ColorScheme.gray, onClick: onClose }, cancelButtonText),
                    React.createElement(Button, { variant: Variant.solid, size: Size.md, colorScheme: scheme, onClick: onConfirm }, confirmButtonText))))));
};
ModalConfirm.displayName = "ModalConfirm";

pick(Size, ["sm", "md", "lg"]);
pick(Variant, [
    "outline",
    "filled",
    "flushed",
    "unstyled",
]);
/**
 * The number input
 */
const NumberInput = forwardRef$1((_a, ref) => {
    var { className, keepWithinRange = true, showStepper = true, name, error, label, helper, size, variantColor, colorScheme } = _a, rest = __rest(_a, ["className", "keepWithinRange", "showStepper", "name", "error", "label", "helper", "size", "variantColor", "colorScheme"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const focusBorderColor = useColorModeValue$1(`${scheme}.500`, transparentize(`${scheme}.500`, 0.5)(theme));
    const errorBorderColor = useColorModeValue$1(`${ColorScheme.error}.500`, transparentize(`${ColorScheme.error}.500`, 1)(theme));
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(NumberInput$1, Object.assign({}, rest, { name: name, size: size, focusBorderColor: focusBorderColor, errorBorderColor: errorBorderColor, className: className, keepWithinRange: keepWithinRange }),
            React.createElement(NumberInputField, { ref: ref }),
            showStepper && (React.createElement(NumberInputStepper, null,
                React.createElement(NumberIncrementStepper, null),
                React.createElement(NumberDecrementStepper, null))))));
});
NumberInput.displayName = "NumberInput";

pick(Size, ["sm", "md", "lg"]);
/**
 * Radios are used when only one choice may be selected in a series of options.
 */
const Radio = forwardRef((props, ref) => {
    const { className, colorScheme, variantColor } = props, rest = __rest(props, ["className", "colorScheme", "variantColor"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(Radio$1, Object.assign({}, rest, { ref: ref, colorScheme: scheme, className: className })));
});
Radio.displayName = "Radio";

const RadioGroup = (props) => {
    var _a;
    const { className, colorScheme, variantColor = ColorScheme.primary, spacing = Spacing[2], options, children, label, name, error, helper, size, isInline } = props, rest = __rest(props, ["className", "colorScheme", "variantColor", "spacing", "options", "children", "label", "name", "error", "helper", "size", "isInline"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(RadioGroup$1, Object.assign({}, rest, { size: size, name: name, colorScheme: scheme, className: className }),
            React.createElement(Stack$1, { spacing: spacing, direction: isInline ? "row" : "column" }, (_a = options === null || options === void 0 ? void 0 : options.map(({ label: radioLabel, value, isDisabled }) => (React.createElement(Radio, { value: value, isDisabled: isDisabled, key: radioLabel, size: size, colorScheme: scheme }, radioLabel)))) !== null && _a !== void 0 ? _a : children))));
};
RadioGroup.displayName = "RadioGroup";

const SelectSize = pick(Size, ["sm", "md", "lg"]);
const SelectVariant = pick(Variant, [
    "outline",
    "filled",
    "flushed",
    "unstyled",
]);
/**
 * Select component is a component that allows users pick a value from predefined options.
 * Ideally, it should be used when there are more than 5 options, otherwise you might consider using a radio group instead.
 */
const Select = forwardRef((props, ref) => {
    var _a;
    const { className, variantColor, colorScheme, options, children, label, name, error, helper, size } = props, rest = __rest(props, ["className", "variantColor", "colorScheme", "options", "children", "label", "name", "error", "helper", "size"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const focusBorderColor = useColorModeValue$1(`${scheme}.500`, transparentize(`${scheme}.700`, 0.5)(theme));
    const errorBorderColor = useColorModeValue$1(`${ColorScheme.error}.500`, transparentize(`${ColorScheme.error}.200`, 0.5)(theme));
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(Select$1, Object.assign({}, rest, { ref: ref, name: name, size: size, focusBorderColor: focusBorderColor, errorBorderColor: errorBorderColor, className: className, colorScheme: scheme }), (_a = options === null || options === void 0 ? void 0 : options.map(({ label: selectLabel, value }) => (React.createElement("option", { value: value, key: selectLabel }, selectLabel)))) !== null && _a !== void 0 ? _a : children)));
});
Select.displayName = "Select";

/**
 * An accessible tabs component
 */
const Tabs = forwardRef((_a, ref) => {
    var { colorScheme, variantColor = "primary", children, isLazy = true } = _a, props = __rest(_a, ["colorScheme", "variantColor", "children", "isLazy"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(Tabs$1, Object.assign({ ref: ref, colorScheme: scheme, isLazy: isLazy }, props), children));
});
Tabs.displayName = "Tabs";
const TabList = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(TabList$1, Object.assign({}, props), children);
};
const TabPanels = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(TabPanels$1, Object.assign({}, props), children);
};
const TabPanel = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(TabPanel$1, Object.assign({}, props), children);
};
const Tab = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(Tab$1, Object.assign({}, props), children);
};

/**
 * Tag component is used for items that need to be labeled, categorized, or organized using keywords that describe them.
 */
const Tag = forwardRef((_a, ref) => {
    var { className, showCloseButton, children, size = Size.md, variant = Variant.solid, variantColor, colorScheme, rightIcon, leftIcon, onCloseButtonClick, isDisabled } = _a, rest = __rest(_a, ["className", "showCloseButton", "children", "size", "variant", "variantColor", "colorScheme", "rightIcon", "leftIcon", "onCloseButtonClick", "isDisabled"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(Tag$1, Object.assign({ ref: ref }, rest, { className: className, size: size, variant: variant, colorScheme: scheme }),
        leftIcon &&
            renderIcon(leftIcon, size, {
                mr: "0.3rem",
                ml: 0,
                verticalAlign: "top",
                m: undefined,
            }),
        React.createElement(TagLabel, null, children),
        rightIcon &&
            renderIcon(rightIcon, size, {
                ml: "0.3rem",
                mr: 0,
                verticalAlign: "top",
                m: undefined,
            }),
        showCloseButton && (React.createElement(TagCloseButton, { onClick: onCloseButtonClick, isDisabled: isDisabled }))));
});
Tag.displayName = "Tag";

/**
 * The Textarea component allows you to easily create multi-line text inputs.
 */
const Textarea = forwardRef((props, ref) => {
    const { className, variantColor, colorScheme, label, name, error, helper, size, wrapperStyle } = props, rest = __rest(props, ["className", "variantColor", "colorScheme", "label", "name", "error", "helper", "size", "wrapperStyle"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size, css: wrapperStyle },
        React.createElement(Textarea$1, Object.assign({}, rest, { ref: ref, size: size, name: name, focusBorderColor: scheme && `${scheme}.500`, errorBorderColor: ColorScheme.error && `${ColorScheme.error}.500`, className: className, colorScheme: scheme }))));
});
Textarea.displayName = "Textarea";

/**
 * A tooltip is a brief, informative message that appears when a user interacts with an element.
 * Tooltips are usually initiated in one of two ways: through a mouse-hover gesture or through
 *  a keyboard-hover gesture.
 */
const Tooltip = forwardRef((_a, ref) => {
    var { className, label, placement = Placement.bottom, hasArrow = true, children, colorScheme, variantColor = ColorScheme.gray } = _a, rest = __rest(_a, ["className", "label", "placement", "hasArrow", "children", "colorScheme", "variantColor"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const bgColor = useColorModeValue$1(`${scheme}.500`, `${scheme}.200`);
    return (React.createElement(Tooltip$1, Object.assign({}, rest, { ref: ref, p: Spacing[2], label: label, className: className, "aria-label": label, placement: placement, hasArrow: hasArrow, bg: bgColor, backgroundColor: bgColor, colorScheme: scheme, shouldWrapChildren: true }), children));
});
Tooltip.displayName = "Tooltip";

/**
 * Wrap is a layout component used to add space between elements and wraps automatically if there isn't enough space.
 */
const Wrap = forwardRef((_a, ref) => {
    var { className, shouldWrapChildren = true } = _a, rest = __rest(_a, ["className", "shouldWrapChildren"]);
    return (React.createElement(Wrap$1, Object.assign({}, rest, { ref: ref, className: className, shouldWrapChildren: shouldWrapChildren })));
});
Wrap.displayName = "Wrap";
const WrapItem = WrapItem$1;

/* eslint-disable react-hooks/exhaustive-deps */
const isServer = typeof window === "undefined";
function renderPlaceholder(element, height = 0, placeholderComponent) {
    return React.createElement(element, {
        style: { height },
    }, placeholderComponent);
}
/**
 * Component for lazy rendering of child react components
 */
const LazyRender = memo(({ rootElement, wrapElement = "div", placeholderElement = "div", visibleOffset = 0, idleTimeout = 500, placeholderHeight: defaultPlaceholderHeight = 0, lazyBehavior = "keepMounted", placeholderComponent, onChange, children, }) => {
    const [isVisible, setIsVisible] = useState(isServer);
    const [isEnabled, setIsEnabled] = useState(!(isVisible && lazyBehavior === "keepMounted"));
    const placeholderHeight = useRef(defaultPlaceholderHeight);
    const intersectionRef = useRef(null);
    function handleVisible(isElementVisible) {
        if (isEnabled) {
            setIsVisible(isElementVisible);
            if (isElementVisible && lazyBehavior === "keepMounted") {
                setIsEnabled(false);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(isElementVisible);
        }
    }
    // Set visibility with intersection observer
    useEffect(() => {
        const intersectionElement = intersectionRef.current;
        if (isEnabled && intersectionElement) {
            const observer = new IntersectionObserver((entries) => {
                // Optimization to run during a browser's idle periods
                if (window === null || window === void 0 ? void 0 : window.requestIdleCallback) {
                    window.requestIdleCallback(() => handleVisible(entries[0].isIntersecting), {
                        timeout: idleTimeout,
                    });
                }
                else {
                    handleVisible(entries[0].isIntersecting);
                }
            }, {
                root: rootElement,
                rootMargin: `${visibleOffset}px 0px ${visibleOffset}px 0px`,
            });
            observer.observe(intersectionElement);
            return () => {
                if (intersectionElement) {
                    observer.unobserve(intersectionElement);
                }
            };
        }
    }, [isEnabled, intersectionRef, idleTimeout, visibleOffset, rootElement]);
    // Set true height for placeholder element after render
    useEffect(() => {
        if (isEnabled && intersectionRef.current) {
            placeholderHeight.current = intersectionRef.current.offsetHeight;
        }
    }, [isEnabled, isVisible, intersectionRef, lazyBehavior]);
    if (!isEnabled) {
        return React.createElement(React.Fragment, null, children);
    }
    const placeholder = renderPlaceholder(placeholderElement, placeholderHeight.current, placeholderComponent);
    return React.createElement(wrapElement, { ref: intersectionRef }, isVisible ? React.createElement(React.Fragment, null, children) : placeholder);
});
LazyRender.displayName = "LazyRender";
var LazyRender$1 = React.memo(LazyRender);

/**
 * Skeleton is used to display the loading state of some components
 */
const Skeleton = (props) => {
    return React.createElement(Skeleton$1, Object.assign({}, props));
};
Skeleton.displayName = "Skeleton";
const SkeletonCircle = (props) => {
    return React.createElement(SkeletonCircle$1, Object.assign({}, props));
};
SkeletonCircle.displayName = "SkeletonCircle";
const SkeletonText = (props) => {
    return React.createElement(SkeletonText$1, Object.assign({}, props));
};
SkeletonText.displayName = "SkeletonText";

export { Alert, Align, Avatar, AvatarSize, Box, Button, ButtonGroup, ButtonSize, ButtonVariant, Checkbox, CheckboxGroup, CheckboxSize, Collapse, Color, ColorScheme, CompassColor, Loader as CompassLoader, Container, Datepicker, Direction, Divider, FileInputButton, Fonts, SimpleGrid as Grid, H1, H2, H3, H4, H5, H6, Heading, Icon, IconButton, IconSize, Image, Input, InputSize, InputVariant, Justify, Kbd, LazyRender$1 as LazyRender, Link, List, ListItem, Loader$2 as Loader, LoaderSize, LoaderView, Menu, MenuButton, ModalAlert, ModalConfirm, Loader$1 as NoomLoader, NumberInput, Placement, Popover, Radio, RadioGroup, Select, SelectSize, SelectVariant, Size, Skeleton, SkeletonCircle, SkeletonText, Spacing, Stack, Box as StackItem, Status, Tab, TabList, TabPanel, TabPanels, Tabs, Tag, Text, Textarea, TP as ThemeProvider, Tooltip, Variant, VariantColor, Wrap, WrapItem, compassTheme$1 as compassTheme, darken, extendCompassTheme, extendInternalTheme, extendTheme, generateColorPalette, getValidChildren, index as internalTheme, lighten, pick, renderIcon, splitTimeUnit, defaultTheme$1 as theme, useComponentSize };
//# sourceMappingURL=index.js.map
